import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FirebaseDynamicLinks } from "@pantrist/capacitor-firebase-dynamic-links";
import { getAuth } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "reactfire";

import { useTranslation } from "react-i18next";
import { useGame } from "context/gameContext";
import { useUser } from "reactfire";
import { useFirestore } from "reactfire";

import { useIonRouter } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
const DeepLinks = () => {
  const history = useHistory();

  const { status, data: user } = useUser();

  const {
    state: { userGameData, settings },
    dispatch,
  } = useGame();
  const { t } = useTranslation();

  const [pendingInvite, setPendingInvite] = useState(undefined);
  const [pendingInviteRefer, setPendingInviteRefer] = useState(undefined);

  const firestore = useFirestore();
  const ionRouter = useIonRouter();

  const functions = useFunctions();
  const inviteUserToLeague = httpsCallable(functions, "inviteToLeague", {
    timeout: 530000,
  });

  useEffect(() => {
    const unlisten = FirebaseDynamicLinks.addListener(
      "deepLinkOpen",
      (data) => {
        const queryParameters = new URL(data.url);
        const refer = queryParameters.searchParams.get("referredBy");
        const league = queryParameters.searchParams.get("leagueId");
        const mode = queryParameters.searchParams.get("mode");
        const slug = data.url.split(".link").pop();

        if (refer) {
          if (getAuth().currentUser) {
            if (league) {
              setPendingInvite(league);
              setPendingInviteRefer(refer);
            }
          } else {
            /* signInAnon().then(function (response) {
              let newUserId = getAuth().currentUser?.uid;

              if (league && newUserId) {
                setPendingInvite(league);
                setPendingInviteRefer(refer);
              }

              if (slug) {
                //navigate(slug);
              }
            }); */
          }
        } else if (mode === "signIn") {
          dispatch({ type: "setHideBottomBar", value: true });

          history.push({
            pathname: "/completeSignup",
            search: "?mode=signIn",
            state: { url: data.url },
          });
        }
      }
    );

    return () => {
      if (Capacitor.isNativePlatform()) {
        unlisten();
      }
    };
  }, []);

  useEffect(() => {
    //todo called twice
    if (!userGameData) return;
    if (!pendingInvite) return;
    if (!user) return;

    let data = {
      type: "invite",
      toUserId: user.uid,
      fromUser: {
        name: null,
        id: pendingInviteRefer,
        photo: null,
      },
      leagueId: pendingInvite,
    };

    inviteUserToLeague(data)
      .then((result) => {
        const data = result.data;
        const sanitizedMessage = data.text;
        setPendingInvite(undefined);
        setPendingInviteRefer(undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [userGameData, user, pendingInvite]);

  useEffect(() => {
    if (!userGameData) return;

    if (
      !userGameData?.completedOnboarding &&
      !window.location.pathname.includes("/completeSignup")
    ) {
      try {
        history.push({
          pathname: "/completeSignup",
          search: "?mode=onBoard",
          state: { isNewSocialUser: true },
        });
      } catch (error) {
        console.log(error);
      }
    }
  }, [userGameData]);

  const signInEmailLink = async (url) => {
    try {
      history.push({
        pathname: "/completeSignup",
        search: "?mode=signIn",
        state: { url: url },
      });
      //history.push("/");
    } catch (error) {
      console.log(error);
    }
  };

  return null;
};

export default DeepLinks;
